import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Analyze from "@/pages/Analyze";
import Import from "@/pages/Import";
import History from "@/pages/History";
import RelationshipDetail from "@/pages/RelationshipDetail";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Pricing from "@/pages/Pricing";
import WhatsAppImport from "@/pages/WhatsAppImport";
import Doctor from "@/pages/Doctor";
import PsychProfile from "@/pages/PsychProfile";
import Admin from "@/pages/Admin";
import Ambassador from "@/pages/Ambassador";
import MagicCallback from "@/pages/MagicCallback";
import Quiz from "@/pages/Quiz";
import Creators from "@/pages/Creators";
import Pro from "@/pages/Pro";
import { MentionsLegales, Confidentialite, CGU } from "@/pages/Legal";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/auth/magic" element={<MagicCallback />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/createurs" element={<Creators />} />
      <Route path="/pro" element={<Pro />} />
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><Import /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/relationship/:id" element={<ProtectedRoute><RelationshipDetail /></ProtectedRoute>} />
      <Route path="/analyze" element={<ProtectedRoute><Analyze /></ProtectedRoute>} />
      <Route path="/analysis/:id" element={<ProtectedRoute><AnalysisDetail /></ProtectedRoute>} />
      <Route path="/whatsapp" element={<ProtectedRoute><WhatsAppImport /></ProtectedRoute>} />
      <Route path="/doctor" element={<ProtectedRoute><Doctor /></ProtectedRoute>} />
      <Route path="/profile/:id" element={<ProtectedRoute><PsychProfile /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/ambassadeur" element={<ProtectedRoute><Ambassador /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/cgu" element={<CGU />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
